<template>
  <div class="download-select">
    <el-form :model="form" inline>
      <!-- 证明类型 -->
      <el-form-item :label="$t('1883')" required>
        <el-select v-model="form.certificate_state" :placeholder="$t('221')">
          <el-option :label="item" :value="Number(key)" v-for="(item, key) in certificateStates" :key="key">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 部门 -->
      <el-form-item :label="$t('19')">
        <Dep :change="changeDep" :mprop="{ checkStrictly: true }" />
      </el-form-item>
      <!-- 职位 -->
      <el-form-item :label="$t('24')">
        <job-select v-model="form.job_title_id" />
      </el-form-item>
      <!-- 员工信息 -->
      <el-form-item :label="$t('3')">
        <el-input
          style="width: 300px; max-width: 500px"
          type="text"
          v-model="form.search_name"
          :placeholder="`${$t('22')}、${$t('25')}、${$t('825')}`"
          clearable
        />
      </el-form-item>

      <el-form-item>
        <!-- 查询 -->
        <el-button type="primary" @click="getTableList" :disabled="!form.certificate_state">{{ $t('80') }}</el-button>
      </el-form-item>
    </el-form>
    <!-- 列表 -->
    <div>
      <div class="page-wrap margin-bottom">
        <!-- 选中状态下并且存在证明类型 -->
        <el-button
          type="primary"
          icon="el-icon-download"
          size="small"
          @click="handleMutiple"
          :loading="mutipleLoading"
          :disabled="!form.certificate_state || !Boolean(mutipleSelect.length)"
          >{{ $t('1884') }}</el-button
        >
      </div>
      <el-table ref="table" :data="tableData" style="width: 100%" border @selection-change="handleSelectionChange">
        <template>
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column fixed="right" :label="$t('70')">
            <template slot-scope="scope">
              <el-button @click="download(scope.row)" type="text" size="small">
                {{ $t('225') }}
              </el-button>
            </template>
          </el-table-column>
        </template>
        <el-table-column v-for="(key, value, index) in tableColumn" :key="index" :prop="value" :label="key" />
      </el-table>
      <el-pagination
        :current-page="form.page"
        class="page-wrap"
        :page-size="20"
        @current-change="handleCurrentChange"
        layout="prev, pager, next, total"
        :total="form.total"
      >
      </el-pagination>
    </div>
    <download-staff ref="downloadStaff" />
  </div>
</template>

<script>
import { certificateInit, certificateDown, certificateLists } from 'api/payroll/prove-download'
import DownloadStaff from './download-staff'
// 部门
import Dep from '@/components/department'
// 部门列表
import JobSelect from '@/components/jobSelect'

export default {
  components: { Dep, JobSelect, DownloadStaff },
  data() {
    return {
      form: {
        certificate_state: '', // 证明类型，1：在职证明，2：工资证明，3：就业证明
        department_id: '', // 部门
        job_title_id: '', // 职位
        search_name: '', // 工号、姓名、手机号
        page: 1, // 当前页
        page_size: 20, // 每页数量
        total: 0
      },
      // 批量下载loading
      mutipleLoading: false,
      // 批量下载
      mutipleSelect: [],
      certificateStates: [], // 证明类型
      tableColumn: [], // table 列
      tableData: []
    }
  },
  mounted() {
    certificateInit().then(res => {
      this.certificateStates = res.data.certificate_state
    })
  },
  methods: {
    handleCurrentChange(val) {
      this.form.page = val
      this.getTableList()
    },
    // 获取表格信息
    getTableList() {
      certificateLists(this.form).then(res => {
        const { header, body, page_data } = res.data
        this.tableColumn = header
        this.tableData = body
        this.form.total = page_data.total
      })
    },
    // 表格选中
    handleSelectionChange(params) {
      this.mutipleSelect = params
    },
    // 批量下载
    handleMutiple() {
      const staffs = this.mutipleSelect.map(item => item.staff_id)
      this.mutipleLoading = true
      certificateDown({ staff_id: staffs, ...this.form })
        .then(res => {
          this.$message.success(res.message)
          this.$refs.table.clearSelection(false)
          this.mutipleSelect = []
        })
        .finally(() => (this.mutipleLoading = false))
    },
    // 下载
    download(row) {
      this.$refs.downloadStaff.init(row)
    },
    changeDep(params) {
      const depart = params[0]
      this.form.department_id = depart?.department_id || ''
    }
  }
}
</script>
